// Shared role policy for navigation and route gates. Backend APIs enforce data scope.
export const MANAGEMENT_ROLES = ['admin', 'operating_head'];
export const TASK_ROLES = [...MANAGEMENT_ROLES, 'counselor', 'team_leader', 'telecaller'];
export const LEAD_ROLES = [...MANAGEMENT_ROLES, 'counselor', 'team_leader'];
export const ADMISSION_ROLES = [...LEAD_ROLES, 'accountant', 'documentation_team'];
export const EXCEPTION_ROLES = [...MANAGEMENT_ROLES, 'team_leader'];
export const STAFF_ROLES = [...TASK_ROLES, 'accountant', 'documentation_team'];

export const homeForRole = role => role === 'telecaller' ? '/tasks'
  : ['accountant', 'documentation_team'].includes(role) ? '/admissions'
  : LEAD_ROLES.includes(role) ? '/' : '/profile';

const items = [
  ['Dashboard', '/', 'fas fa-home', LEAD_ROLES],
  ['Leads', '/leads', 'fas fa-user-plus', LEAD_ROLES],
  ['Tasks', '/tasks', 'fas fa-list-check', TASK_ROLES],
  ['Admissions', '/admissions', 'fas fa-graduation-cap', ADMISSION_ROLES],
  ['Finance', '/finance', 'fas fa-rupee-sign', ['admin', 'accountant']],
  ['Incentives', '/incentive-dashboard', 'fas fa-trophy', LEAD_ROLES],
  ['My Incentives', '/my-incentives', 'fas fa-coins', ['telecaller', 'documentation_team']],
  ['AI Insights', '/ai-insights', 'fas fa-robot', MANAGEMENT_ROLES],
  ['Sales & Marketing', '/marketing', 'fas fa-bullhorn', MANAGEMENT_ROLES],
  ['Users', '/users', 'fas fa-user-cog', ['admin']],
  ['Settings', '/settings', 'fas fa-cog', STAFF_ROLES],
];

export const navigationForRole = (role, pathname) => items
  .filter(([, , , roles]) => roles.includes(role))
  .map(([name, href, icon]) => ({ name, href, icon,
    id: name.toLowerCase().replace(/[^a-z0-9]+/g, '-'),
    current: href === '/' ? pathname === '/' : pathname === href || pathname.startsWith(`${href}/`)
      || (href === '/admissions' && pathname.startsWith('/student-portal/'))
      || (href === '/leads' && /^\/(students|student|student-profile|prospects)\//.test(pathname)),
  }));